/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import Icon from '@mui/icons-material/PlayArrow';
import { useTheme } from 'styled-components';
import { IconButton } from './IconButton';
import { IconButtonProps } from './types';

export const PlayIconButton = ({
    disabled,
    iconColor,
    sx,
    ...rest
}: IconButtonProps) => {
    const theme = useTheme();
    return (
        <IconButton disabled={disabled} {...rest}>
            <Icon
                data-test-id='PlayArrowIcon'
                disabled={disabled}
                sx={{
                    ...sx,
                    color: iconColor || theme.color('primary'),
                }}
            />
        </IconButton>
    );
};
